import hasClipboardElementData from './has-clipboard-element-data';

export default {
  hasClipboardElementData,
};
